import { graphql, useStaticQuery } from 'gatsby';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';

import { FlowIdTypes } from '@folx-types/flow';
import { IFlowStepProps } from '@folx-types/flow-steps';

import SelectAppointmentStep, {
	ISelectAppointmentStepContent,
} from './SelectAppointmentStep.component';

interface ISelectAppointmentStepPageProps extends IFlowStepProps {
	serviceType?: FlowIdTypes;
	path: string;
}

const SelectAppointmentStepPage: FC<ISelectAppointmentStepPageProps> = ({ serviceType }) => {
	const { pageContent } = useStaticQuery<Record<string, string>>(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-appointment-selection" }) {
				appointment_selection_header_description
			}
		}
	`);

	const refinedContent: ISelectAppointmentStepContent = keysToCamel(
		pageContent
	) as ISelectAppointmentStepContent;

	return <SelectAppointmentStep refinedContent={refinedContent} serviceType={serviceType} />;
};

export default SelectAppointmentStepPage;
